import { motion } from 'motion/react'
import styled from 'styled-components'

export const MotionMask = styled.div`
  overflow: hidden;
`
export const MotionWrapper = styled(motion.span)`
  display: inline-block;
`

export const Separator = styled(motion.span)`
  display: block;
  height: 1px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.black};
  opacity: 0.5;
  transform-origin: center left;
`

export const SeparatorAbsolute = styled(Separator)`
  position: absolute;
  inset: 0 auto auto 0;
`
